import {
  action,
  computed,
  runInAction,
  makeObservable,
  observable,
} from 'mobx';
import { Services } from '@project/API';
import { SearchGeocode } from '@project/API/resources/search';

type ResultFeature = GeoJSON.Feature<
  GeoJSON.Point,
  { address: string; accuracy?: number }
>;

type parameters = {
  type: string;
  address: string;
};

export class Search {
  private _services: Services;
  @observable private _parameters: parameters | undefined = undefined;
  @observable private _features: ResultFeature[] = [];
  @observable private _error: string | undefined = undefined;
  @observable private _isLoading: boolean = false;

  constructor(services: Services) {
    this._services = services;
    makeObservable(this);
  }

  set parameters(params: parameters | undefined) {
    this._parameters = params;
    this.loadData();
  }

  get parameters(): parameters | undefined {
    return this._parameters;
  }

  @computed get features() {
    return this._features;
  }

  @computed get error() {
    return this._error;
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @action loadData = async () => {
    runInAction(() => {
      this._error = undefined;
      this._isLoading = true;
    });

    try {
      let result: ResultFeature[] = [];

      if (this._parameters) {
        const collection: SearchGeocode = await this._services.search.list(
          this._parameters.type,
          this._parameters.address,
        );

        if (collection.features instanceof Array) {
          result = collection.features;
        }
      }

      runInAction(() => {
        this._features = result;
      });
    } catch (e) {
      this._error = 'Не удалось загрузить страницу';
    } finally {
      runInAction(() => (this._isLoading = false));
    }
  };
}
